import { createScopedDescriptor } from 'quartz-core-utils/globalState/api';
import { getBuildTimePropertyNames } from 'quartz-core-utils/globalState/initialize';
// Properties initialized in quartz-core-utils/globalState/initialize.ts
export const COPILOT_LAYOUT_TYPE = createScopedDescriptor(getBuildTimePropertyNames().copilotLayoutType, 'BROWSING_CONTEXT');